import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

const Navbar = () => {
    return (
        <div className="container">
            <nav class="navbar navbar-expand-lg navbar-light pt-4 pb-5">
                <div class="container-fluid">
                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
                        <div class="navbar-nav ms-auto">
                            <li>
                                <Link className="header me-5" to="/home"><strong>Home</strong></Link>
                            </li>
                            <li>
                                <Link className="header me-5" to="/about"><strong>About</strong></Link>
                            </li>
                            <li>
                                <Link className="header me-5" to="/projects"><strong>Projects</strong></Link>
                            </li>
                            <li>
                                <Link className="header me-5" to="/blogs"><strong>Blogs</strong></Link>
                            </li>
                            <li>
                                <Link className="header me-5" to="/contactMe"><strong>Contact me</strong></Link>
                            </li>
                            <li>
                                <a className="header border border-3 border-success" href="https://drive.google.com/uc?export=download&id=1VRDqwwry2InWcilOetyqGgO82ThpaSAl"><strong><FontAwesomeIcon icon={faDownload}/> Resume</strong></a>
                            </li>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    );
};

export default Navbar;